const inventorySetupStyles = (theme) => ({
  header: {
    marginTop: "20px",
  },
  inventorySetupHeader: {
    fontFamily: "Lexend",
    color: theme?.palette?.primary?.main || "#0F0F0F",
    fontWeight: 400,
    fontSize: { xs: "24px", sm: "28px", md: "32px" },
    lineHeight: "normal",
  },
  inventorySetupSubHeader: {
    marginTop: "12px",
    marginBottom: "32px",
    fontFamily: "Lexend",
    color: theme?.palette?.customColor?.secondarySecond || "#656565",
    fontWeight: 300,
    fontSize: "16px",
    lineHeight: "24px",
  },
  productCell: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },
  productImageWrapCell: {
    border: "0.62px solid #CBCBCB",
    width: "40px",
    height: "40px",
  },
  switchWrap: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },
  customSwitch: (isActive) => ({
    width: "40px",
    height: "15px",
    backgroundColor: isActive 
      ? (theme?.palette?.customColor?.green || "#4CAF50")
      : (theme?.palette?.customColor?.secondarySecond || "#E0E0E0"),
    borderRadius: "30px !important",
    cursor: "pointer",
    position: "relative",
    transition: "0.3s ease",
    "& .MuiSwitch-track": {
      backgroundColor: "transparent !important",
    },
    "& .MuiSwitch-thumb": {
      position: "absolute",
      top: "4px",
      left: "4px",
      width: "16px",
      height: "16px",
      backgroundColor: `${theme?.palette?.customColor?.white || "#FFFFFF"} !important`,
      borderRadius: "50%",
      transition: "transform 0.3s ease",
    },
    "&.Mui-checked .MuiSwitch-thumb": {
      transform: "translateX(-3px) !important",
    },
  }),
  customSwitchText: {
    fontFamily: "Lexend",
    fontWeight: 400,
    fontSize: "12px",
    marginLeft: "10px",
    lineHeight: "15px",
    color: theme?.palette?.primary?.main || "#0F0F0F",
  },
  addBtn: {
    width: "100%",
    padding: "9px",
    marginTop: "20px",
    fontSize: "16px",
    fontWeight: 400,
    textTransform: "none",
    border: `1px solid ${theme?.palette?.primary?.main || "#0F0F0F"}`,
    borderRadius: "0px",
  },
  textAlign: {
    textAlign: "center",
  },
  moreIcon: {
    position: "relative",
  },
  moreWrap: {
    position: "absolute",
    padding: "20px",
    border: `0.8px solid ${theme?.palette?.customColor?.secondaryThird || "#CBCBCB"}`,
    width: "110px",
    height: "70px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    zIndex: 100,
    textAlign: "start",
    top: "35px",
    background: theme?.palette?.customColor?.white || "#FFFFFF",
    right: "25px",
  },
  moreOption: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    cursor: "pointer",
  },
  moreText: {
    fontFamily: "Lexend",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "21px",
  },
  removeText: {
    color: theme?.palette?.customColor?.red || "#B60218",
  },
  boxImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  addFormWrap: {
    marginTop: "50px",
    width: { xs: "100%", sm: "96.5vw" },
    background: { xs: "none", sm: theme?.palette?.customColor?.secondaryFirst || "#F5F5F5" },
    margin: { xs: "0px !important", sm: "0px !important" },
    padding: { xs: "0px !important", sm: "30px 30px 100px 30px !important" },
    position: "relative",
    top: { xs: "0px", sm: "25px" },
    left: { 
      xs: "0px", 
      sm: "-106px",
      md: "-255px",
      lg: "-263px",
      xl: "-310px"
    },
  },
  webTable: {
    display: { xs: "none", sm: "table" },
  },
  showMbTable: {
    display: { xs: "block", sm: "none" },
  },
  mbTable: {
    margin: "20px 0px",
    border: `0.5px solid ${theme?.palette?.customColor?.secondaryThird || "#CBCBCB"}`,
    padding: "15px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  mbTablePart1: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  mbTablePart2: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  mbSwitchMore: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },
  mbTableHead: {
    fontFamily: "Lexend",
    color: theme?.palette?.customColor?.secondarySecond || "#656565",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "15px",
  },
  mbTableBody: {
    fontFamily: "Lexend",
    color: theme?.palette?.primary?.main || "#0F0F0F",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "17.5px",
  },
  productName: {
    width: "100px",
    wordBreak: "break-all",
  },
  tableCell: {
    fontFamily: "Lexend",
    color: theme?.palette?.customColor?.placeholder || "#959595",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "15px",
  },
});

export default inventorySetupStyles;

